/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/Actions", "../FluxCommon/ActionsHubManager", "./WorkloadsActions"], function (require, exports, Actions_1, ActionsHubManager_1, WorkloadsActions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WorkloadsActionsCreator = /** @class */ (function (_super) {
        __extends(WorkloadsActionsCreator, _super);
        function WorkloadsActionsCreator() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WorkloadsActionsCreator.getKey = function () {
            return "workloads-actionscreator";
        };
        WorkloadsActionsCreator.prototype.initialize = function (instanceId) {
            this._actions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(WorkloadsActions_1.WorkloadsActions);
        };
        WorkloadsActionsCreator.prototype.getDeployments = function (kubeService) {
            var _this = this;
            kubeService.getDeployments().then(function (deploymentList) {
                _this._actions.deploymentsFetched.invoke(deploymentList);
            });
        };
        WorkloadsActionsCreator.prototype.getReplicaSets = function (kubeService) {
            var _this = this;
            kubeService.getReplicaSets().then(function (replicaSetsList) {
                _this._actions.replicaSetsFetched.invoke(replicaSetsList);
            });
        };
        WorkloadsActionsCreator.prototype.getDaemonSets = function (kubeService) {
            var _this = this;
            kubeService.getDaemonSets().then(function (daemonSetsList) {
                _this._actions.daemonSetsFetched.invoke(daemonSetsList);
            });
        };
        WorkloadsActionsCreator.prototype.getStatefulSets = function (kubeService) {
            var _this = this;
            kubeService.getStatefulSets().then(function (statefulSetsList) {
                _this._actions.statefulSetsFetched.invoke(statefulSetsList);
            });
        };
        WorkloadsActionsCreator.prototype.getPods = function (kubeService) {
            var _this = this;
            kubeService.getPods().then(function (podsList) {
                _this._actions.podsFetched.invoke(podsList);
            });
        };
        return WorkloadsActionsCreator;
    }(Actions_1.ActionCreatorBase));
    exports.WorkloadsActionsCreator = WorkloadsActionsCreator;
});
